<template>
  <div class="page-template">
       <div class="page-title">{{ title }}</div>
         <search-form-template
           ref="storeTemplate"
          :searchOptions="storeSearchOptions"
          :toolConfig="toolConfig"
           @searchSubmit="searchSubmit"
           @clear="clearSearch"
           @btnCommon="btnCommon"
        ></search-form-template>
            <el-tabs v-model="activeTab" >
      <el-tab-pane label="按开卡门店" name="trendAnalyse">
        <div class="centerBack">
          <div class="echartsArea">
             <echarts-template class="charts-box" ref="mstoreEcharts"
                               :picOption="mstoreEcharts">
             </echarts-template>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="按会员分类" name="totalAnalyse">
        <div class="centerBack">
          <div class="echartsArea">
            <echarts-template class="charts-catebox" ref="mcategoryEcharts"
                              :picOption="mcategoryEcharts">
            </echarts-template>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import api from '@/config/api';
import userPower from "@/mixin/userPower";
import searchFormTemplate from '@/components/template/searchFormTemplate';
import echartsTemplate from "@/components/controls/echarts";
import {mcategoryEcharts, mstoreEcharts} from '@/page/home/options/reportEcharts'

export default {
   mixins: [userPower],
   components: { searchFormTemplate,echartsTemplate },
data(){
    // let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    // let edCreateDttm = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
    // let defaultParam = { stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm};
    return {
       activeTab: "trendAnalyse",
      //  param: defaultParam,
       mstoreEcharts,
       mcategoryEcharts,
        title:'',
        indexShow: false,
        //开卡门店
        storeSearchOptions:{
          simple: [{
          label: '门店名称',
          type: 'select',
          prop: 'storeId',
          data:[]
        }],
        },
         toolConfig: [
        {
          label: '导出',
          code: 'export',
          callback:this.exportData
        }
      ],
    }
},
created(){
    this.setStore(this.storeSearchOptions.simple);
    this.memberStore(this.param),
    this.memberCategory(this.param)
    this.allStore()
},
mounted(){
     this.title = document.title;
},
 methods: {
     //按开卡门店
     memberStore(param) {
       this.$axios.fetchPost(api.report.meAnalyseEcharts,param).then(data => {
        if (data.code == 200) {
          if(data.data.length ==0){
               this.mstoreEcharts.charsOption.title.text = "暂未查询到相关记录";
               this.mstoreEcharts.charsOption.title.top='center'
               this.mstoreEcharts.charsOption.title.right='center'
               this.mstoreEcharts.charsOption.series[0].data = [{}];
          }else{
             this.mstoreEcharts.charsOption.series[0].data = [];
             this.mstoreEcharts.charsOption.title.text = "会员分析（会员数）-按开卡门店";
             this.mstoreEcharts.charsOption.title.top=5
             this.mstoreEcharts.charsOption.title.right=0
            data.data.map((item) => {
              this.mstoreEcharts.charsOption.series[0].data.push({
                 value: item.memberNum,
                 name: item.storeName,
                 balance:item.balance
              });
              this.mstoreEcharts.charsOption.legend.data.push(item.storeName);
              if ((data.data.memberNum = 0)) {
                this.mstoreEcharts.charsOption.series[0].data = [];
              }
            });
          }
        this.$nextTick(() => {
            this.$refs.mstoreEcharts.drawpic();
          });
        }
      }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
      })
    },
    //按会员分类
    memberCategory(param){
         this.$axios.fetchPost(api.report.meCategoryEcharts,param).then(data => {
        if (data.code == 200) {
           if(data.data.length ==0){
               this.mcategoryEcharts.charsOption.title.text = "暂未查询到相关记录";
               this.mcategoryEcharts.charsOption.title.top='center'
               this.mcategoryEcharts.charsOption.title.right='center'
               this.mcategoryEcharts.charsOption.series[0].data = [{}];
          }else{
             this.mcategoryEcharts.charsOption.title.text = "会员分析（会员数）-按会员分类";
             this.mcategoryEcharts.charsOption.title.top=5
             this.mcategoryEcharts.charsOption.title.right=0
             this.mcategoryEcharts.charsOption.series[0].data = [];
            data.data.map(item=>{
              this.mcategoryEcharts.charsOption.series[0].data.push({
                    value:item.memberNum,
                    name:item.memberCategoryName,
                    balance:item.balance,
              });
              this.mcategoryEcharts.charsOption.legend.data.push(item.memberCategoryName)
              if ((data.data.memberNum = 0)) {
                this.mcategoryEcharts.charsOption.series[0].data = [];
              }
            })
          }
            this.$nextTick(() => {
                this.$refs.mcategoryEcharts.drawpic();
            });
        }
      }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
      })
    },
     searchSubmit() {
       let simpleParam = Object.assign({},this.$refs.storeTemplate.getSimpleParams())
        this.memberStore(simpleParam)
        this.memberCategory(simpleParam)
    },
    clearSearch() {

    },
    btnCommon(btnObj) {
      btnObj.callback && btnObj.callback();
    },
    allStore(){
      let mes=[]
      mes.unshift({name:"所有门店",value:""});
      this.$axios.fetchPost(api.system.seStore+'/list').then(data=>{
        if(data.code===200){
          data.data.unshift({name:"所有门店",value:""});
           this.storeSearchOptions.simple.filter(item=>item.prop==="storeId")[0].data=data.data;
        }
      })
    },
    exportData(){
       let url;
       let fileName;
       let exportcode
       const simpleParams = Object.assign({}, this.$refs.storeTemplate.getSimpleParams());
       if(this.activeTab=="trendAnalyse"){
         url = api.report.meAnalyseExport;
         fileName = '会员分析（会员数）-按开卡门店.xls';
         exportcode = {exportCode: 'memberAnalysisStoreExport'}
       }
      if (this.activeTab == "totalAnalyse") {
        url = api.report.meCategoryExport
        fileName = '会员分析（会员数）-按会员分类.xls';
        exportcode = {exportCode: 'memberAnalysisCategoryExport'}
      }
      let $params = Object.assign({}, simpleParams, exportcode);
      this.$axios.fetchPost(url, $params).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
          this.loadingExt = false;
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '导出异常', type: 'error'});
        }
      })
    }
  }
}
</script>

<style scoped>
  .charts-catebox{
     height: 480px;
     width: calc(100vw - 140px);
  }
  .echartsArea{
    height: 500px;
    width: 100%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 3px 3px 3px #e5e5e5;
    padding: 10px;
    box-sizing: border-box;
    }
</style>



// WEBPACK FOOTER //
// src/page/report/member/conAnalyse.vue